import { render, staticRenderFns } from "./CoursesGrid.vue?vue&type=template&id=49eba056&scoped=true"
import script from "./CoursesGrid.vue?vue&type=script&lang=js"
export * from "./CoursesGrid.vue?vue&type=script&lang=js"
import style0 from "./CoursesGrid.vue?vue&type=style&index=0&id=49eba056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eba056",
  null
  
)

export default component.exports